import { TKey } from "@/app/translations/TKey";
import { FooterSection } from "@/app/types/navigation/FooterSection";
import { HelpPaths, LegalPaths, PublicPaths, ToolLandingPaths } from "@/app/vars/Routes";

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    titleKey: TKey.FOOTER_TOOLS,
    links: [
      { path: ToolLandingPaths.CALL_ANALYSIS, labelKey: TKey.CALL_ANALYSIS },
      { path: ToolLandingPaths.OFFERS, labelKey: TKey.OFFERS_NAV },
      { path: ToolLandingPaths.CLIENT_AVATAR, labelKey: TKey.CLIENT_AVATAR_NAV },
      { path: ToolLandingPaths.PROSPECT_SEARCH, labelKey: TKey.PROSPECT_SEARCH_NAV },
      { path: ToolLandingPaths.MESSAGES_CONTENT, labelKey: TKey.MESSAGES_CONTENT_NAV },
    ],
  },
  {
    titleKey: TKey.FOOTER_RESOURCES,
    links: [
      { path: PublicPaths.BLOG, labelKey: TKey.BLOG_NAV_LABEL },
      { path: HelpPaths.EXTENSION, labelKey: TKey.EXTENSION_GUIDE_TITLE },
      { path: HelpPaths.MCP, labelKey: TKey.MCP_GUIDE_TITLE },
    ],
  },
  {
    titleKey: TKey.FOOTER_LEGAL,
    links: [
      { path: LegalPaths.TERMS, labelKey: TKey.TERMS },
      { path: LegalPaths.PRIVACY, labelKey: TKey.PRIVACY },
    ],
  },
];
